import { SDKProps } from '@rokt/types/sdk';
import { linkToRoot } from '@tm-spon/upsell-display-ui';

import { UpsellsCartData } from './types';

export const loadSponsorshipUI = (SDKProps: SDKProps, cartData?: UpsellsCartData) => {
  const roktPlaceholder = document.getElementById('rokt-placeholder');
  if (roktPlaceholder) {
    require('@tm-spon/upsell-display-ui/dist/fonts.css');
    linkToRoot(roktPlaceholder, SDKProps, cartData);
  }
};
